export default __webpack_public_path__ + "static/media/ic-work-outline.d1c789d3.svg";